module.exports = __webpack_public_path__ + "img/LSO.8370af75.svg";